import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M101.5 52.64c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M65.5 16a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M20.67 74.85a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M27.79 101.17l3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM101.5 20h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V20h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V23h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
    <path
      fill="#D8FFFF"
      d="M68.47 24H34.91C32.2 24 30 26.23 30 28.98v58.05c0 2.75 2.2 4.98 4.91 4.98h46.18c2.71 0 4.91-2.23 4.91-4.98V41.78L68.47 24.01z"
    />
    <path
      fill="#00D8D8"
      d="M72.05 41.77H86L68.47 24v14.14c0 2 1.6 3.63 3.58 3.63"
    />
    <path
      fill="#001A43"
      d="M59 47.25H41c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h18c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M73 59.29H41a2.29 2.29 0 1 1 0-4.58h32a2.29 2.29 0 1 1 0 4.58M40.55 79.33c-.53 0-1.06-.19-1.49-.57a2.26 2.26 0 0 1-.19-3.18l2.58-2.91a5.96 5.96 0 0 1 7.99-.87l1.7 1.23c.49.36 1.15.38 1.66.05l2.18-1.37a5.96 5.96 0 0 1 7.07.52l1.38 1.18c.46.4 1.11.47 1.66.19l5.53-2.89a2.252 2.252 0 0 1 2.09 3.99l-5.53 2.89a5.95 5.95 0 0 1-6.66-.75l-1.38-1.18c-.5-.42-1.2-.48-1.76-.13L55.2 76.9a5.96 5.96 0 0 1-6.7-.22l-1.7-1.23c-.62-.45-1.48-.36-1.99.22l-2.58 2.91c-.44.5-1.06.76-1.68.76z"
    />
  </svg>
);
const SvgEnrichedIconLeadProposalsBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconLeadProposalsBrand);
export default Memo;
